import Vue from "Vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class InputDate extends Vue {
	@Prop()
	private vmodel;

	@Prop()
	private label;

	@Prop({ default: false })
	private disabled;

	@Prop({ default: false })
	private required;

	@Prop({ default: true })
	private show;

	@Prop({ default: false })
	private error;
	
	public value;

	public focus(e): void {
		e.target.select();
	}

	public change(e): void {
		this.$emit("update:vmodel", e.target.value);
	}

	public blur(e): void {
		this.$emit("changed");
	}

	public paste(e): void {
		e.preventDefault();
	}

	@Watch("vmodel")
	public setDate(): void {
		this.value = this.vmodel;
		this.$forceUpdate();
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/InputDate/input-date.ts